import {Component, OnInit} from '@angular/core';
import {Vector3} from 'three';

import {Coord} from './Quickview';
import {DataExchangeService} from '../../../../../surface3d/src/lib/API/Public/data-exchange.service';


@Component({
    selector: 'burncase-quickview',
    templateUrl: './quickview.component.html',
    styleUrls: ['./quickview.component.css']
})
export class QuickviewComponent implements OnInit {

    private _list = Coord;

    constructor(private dataExchangeService: DataExchangeService) {
    }

    ngOnInit() {
    }

    public setPos(index: number) {
        const obj = this._list[index];
        this.dataExchangeService.setQuickView(new Vector3(obj.camera.x, obj.camera.y, obj.camera.z),
            new Vector3(obj.target.x, obj.target.y, obj.target.z));
    }

}
